/**
 * This is a modified example from https://react-select.com/advanced#sortable-multiselect
 */
import { DragHandleIcon } from '@chakra-ui/icons';
import { Flex } from '@chakra-ui/react';
import React, { MouseEventHandler } from 'react';
import Select, {
  components,
  MultiValueProps,
  Props,
} from 'react-select';
import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

export interface Option {
  readonly value: string;
  readonly label: string;
}

export const SortableMultiValue = SortableElement(
  (props: MultiValueProps<Option>) => {
    // this prevents the menu from being opened/closed when the user clicks
    // on a value to begin dragging it. ideally, detecting a click (instead of
    // a drag) would still focus the control and toggle the menu, but that
    // requires some magic with refs that are out of scope for this example
    const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const innerProps = { ...props.innerProps, onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
  }
);
const SortableHandleWithIcon = SortableHandle(
  (props: any) => 
    <div
      {...props}
      style={{
        width: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <DragHandleIcon boxSize={3}/>
    </div>
);

export const SortableMultiValueLabel = (props: any) => {
  return (
    <Flex className='sortableMultiValueLabel'>
      <SortableHandleWithIcon />
      <components.MultiValueLabel {...props} />
    </Flex>
  );
};

export const SortableSelect = SortableContainer(Select) as React.ComponentClass<
  Props<Option, true> & SortableContainerProps
>;
